import React, { useState } from 'react';
import axios from 'axios';
import { useForm } from 'react-hook-form';
import Modal from 'react-modal';
import ModalImagenUsuario from 'react-modal';
import UsuarioBuscador from './UsuarioBuscador';
import CsvDropzone from './CsvDropzone';
import Swal from 'sweetalert2';
import SubirImagenPerfil from './SubirImagenPerfil ';
import ObtieneDatosCookies from '../obtieneDatosCookiesUsuario';
const GestorUsuariosCalificaciones = () => {
  const usuario=ObtieneDatosCookies()
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const { register, handleSubmit, reset, setValue  } = useForm();
  const [modalAbierto, setModalAbierto] = useState(false);
  const [veoCreaUsuarios, setVeoCreoUsuarios] = useState(false)
  const [modalImagenAbierto, setModalImagenAbierto] = useState(false)
  const estadoVirtual = selectedUser?.virtual?.estado; 
  const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    transform: 'translate(-50%, -50%)',

    width: '90vw',        // 👈 ocupa casi toda la pantalla
    maxWidth: '550px',    // 👈 límite en desktop
    height: 'auto',       // 👈 que crezca según contenido
    maxHeight: '90vh',    // 👈 nunca se sale del alto
    
    padding: '15px',
    overflowY: 'auto',    // 👈 scroll interno si hace falta
    borderRadius: '8px'
  },
};


  const handleEditClick = (user) => {
    setModalAbierto(true);
    setSelectedUser(user);
    reset(user);
  };



  const enviarUsuariosMasivamente = async (usuariosParaEnviar) => {
    const username = process.env.REACT_APP_KEY;
    
    const password = process.env.REACT_APP_PASS;
    const token = btoa(`${username}:${password}`);

    // Normaliza los usuarios para que todos tengan "dni"
    const usuariosNormalizados = usuariosParaEnviar.map(usuario => ({
      ...usuario,
      dni: usuario.dni || usuario.alumnoDni, // por si viene como alumnoDni
    }));

    // Verificación previa con SweetAlert2
    const confirmacion = await Swal.fire({
      title: '¿Confirmar envío?',
      text: `¿Estás seguro que quieres agregar ${usuariosNormalizados.length} usuarios?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, agregar',
      cancelButtonText: 'Cancelar',
    });

    if (!confirmacion.isConfirmed) {
      return Swal.fire('Cancelado', 'No se agregaron usuarios', 'info');
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASEURL}calificaciones/creaUsuariosCalificaciones`,
        usuariosNormalizados,
        {
          headers: {
            Authorization: `Basic ${token}`,
          },
        }
      );

      const { creados, yaExisten, errores } = response.data;

      let mensaje = '';
      if (creados?.length > 0) {
        mensaje += `✅ Usuarios creados: ${creados.join(', ')}\n`;
      }
      if (yaExisten?.length > 0) {
        mensaje += `⚠️ Ya existían: ${yaExisten.join(', ')}\n`;
      }
      if (errores?.length > 0) {
        mensaje += `❌ Errores:\n` + errores.map(e => `DNI ${e.dni}: ${e.error}`).join('\n');
      }

      Swal.fire('Resultado', mensaje || 'Proceso completado', 'success');
    } catch (error) {
      console.error('❌ Error al crear usuarios:', error);
      Swal.fire('Error', 'Ocurrió un error al crear usuarios', 'error');
    }
  };
const [cargando, setCargando] = useState(false);

const sincronizaUsuarios = async () => {
  let progreso = 0;
  let interval;

  Swal.fire({
    title: "Sincronizando usuarios",
    html: `
      <p>Procesando información...</p>
      <b id="porcentaje">0%</b>
    `,
    allowOutsideClick: false,
    allowEscapeKey: false,
    didOpen: () => {
      Swal.showLoading();

      const porcentajeEl = Swal.getPopup().querySelector("#porcentaje");

      interval = setInterval(() => {
        if (progreso < 90) {
          progreso += Math.floor(Math.random() * 5) + 1;
          porcentajeEl.textContent = `${progreso}%`;
        }
      }, 500);
    }
  });

  try {
    const sincronate=await axios.post(
      process.env.REACT_APP_BASEURL + "calificaciones/sincronizarTodos/"
    );

    clearInterval(interval);
    
    Swal.fire({
      icon: "success",
      title: "Sincronización completa",
      text: "Los usuarios fueron sincronizados correctamente",
    });

  } catch (error) {
    clearInterval(interval);

    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Ocurrió un problema durante la sincronización",
    });

    console.error(error);
  }
};
  const onSubmit = (data) => {
    const username = process.env.REACT_APP_KEY;
    const password = process.env.REACT_APP_PASS;
    const token = btoa(`${username}:${password}`);


    axios.post(process.env.REACT_APP_BASEURL + `calificaciones/actualizaUsuarioCalificaciones/${data.dni}`, data, {
      headers: {
        Authorization: `Basic ${token}`,
      },

    })
      .then(response => {
        setUsers(users.map(user => user.dni === data.dni ? response.data.usuario : user));
        setSelectedUser(null);
        setModalAbierto(false);
        alert('Cambio realizado con exito');
      })
      .catch(error => {
        console.error('❌ Error actualizando usuario:', error);
        alert('Error al actualizar el usuario');
      });
  };

  const closeModalInformeDocentes = () => {
    setModalAbierto(false);
  };
  const descargarEjemploCSV = () => {
    const ejemploCSV = `dni,apellido,nombres,email
10000001,Perez,Juan,juan.perez1@example.com
10000002,Gomez,Ana,ana.gomez2@example.com
10000003,Ramirez,Carlos,carlos.ramirez3@example.com
10000004,Lopez,Sofia,sofia.lopez4@example.com`;

    const blob = new Blob([ejemploCSV], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'ejemplo_usuarios.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };
const desvirtualizarUsuario = async () => {
  try {
    const clave = process.env.REACT_APP_KEY4;
    const dni = selectedUser?.dni.toString();

    if (!dni) {
      return Swal.fire("Error", "No hay DNI seleccionado", "error");
    }

    await axios.post(
      "https://wwwp.isepsantafe.net.ar/miIsep/desvirtualizar-usuario",
      { dni, clave }
    );

    // 🔥 ACTUALIZAR ESTADO LOCAL
    setSelectedUser(prev => ({
      ...prev,
      virtual: { estado: "inactivo" }
    }));

    Swal.fire("Éxito", "Usuario desvirtualizado correctamente", "success");

  } catch (error) {
    console.error("❌ Error al desvirtualizar:", error);
    Swal.fire("Error", "No se pudo desvirtualizar el usuario", "error");
  }
};
const virtualizarUsuario = async () => {
  try {
    const clave = process.env.REACT_APP_KEY4;
    const dni = selectedUser?.dni?.toString();
    const identificacion = selectedUser?.dni?.toString();
// console.log("CKAC")
    if (!dni) {
      return Swal.fire("Error", "No hay DNI seleccionado", "error");
    }

    await axios.post(
      "https://wwwp.isepsantafe.net.ar/miIsep/crear-virtual-usuario",
      { dni, clave }
    );

    setSelectedUser((prev) => ({
      ...prev,
      virtual: { estado: "activo" }
    }));

    let copiado = false;

    if (identificacion) {
      try {
        await navigator.clipboard.writeText(identificacion);
        copiado = true;
      } catch (errorClipboard) {
        console.warn(
          "No se pudo copiar usando navigator.clipboard:",
          errorClipboard
        );

        // Respaldo para navegadores que no permiten navigator.clipboard
        const textarea = document.createElement("textarea");
        textarea.value = identificacion;
        textarea.style.position = "fixed";
        textarea.style.opacity = "0";

        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();

        copiado = document.execCommand("copy");

        document.body.removeChild(textarea);
      }
    }

    await Swal.fire({
      icon: "success",
      title: "Usuario virtualizado",
      html: identificacion
        ? `
            <p>El usuario fue virtualizado correctamente.</p>
            <p>
              <strong>Identificación:</strong>
              ${identificacion}
            </p>
            <p>
              ${
                copiado
                  ? "✅ La identificación fue copiada al portapapeles."
                  : "⚠️ No se pudo copiar automáticamente."
              }
            </p>
          `
        : `
            <p>El usuario fue virtualizado correctamente.</p>
            <p>⚠️ El usuario no posee una identificación disponible.</p>
          `,
      confirmButtonText: "Aceptar"
    });

  } catch (error) {
    console.error("❌ Error al virtualizar:", error);

    Swal.fire(
      "Error",
      error?.response?.data?.message ||
        "No se pudo virtualizar el usuario",
      "error"
    );
  }
};
  return (
    <>

 {usuario.destino==7?<><button onClick={sincronizaUsuarios} disabled={cargando}>
  {cargando ? "Sincronizando..." : "Sincronizar usuarios"}
</button></>:""}

      <Modal
        isOpen={modalAbierto}
        onRequestClose={closeModalInformeDocentes}
        ariaHideApp={false}
        style={customStyles}
      >
        <div className="btn-group">

          <button className="btn btn-danger" onClick={closeModalInformeDocentes}>x</button>
          <strong style={{ alignSelf: "center" }}>Edición Usuarios Mi ISeP</strong>
         
        </div>
        <div className="formUsuario">
          <h2>Editar Usuario</h2>


          {selectedUser?.imagen ? (
            <img
              src={`https://wwwa.isepsantafe.net.ar/${selectedUser.imagen}  `}
              alt="Foto Cadete"
              className="rounded-circle border"
              style={{ height: "75px", width: "75px", cursor: "pointer" }}
              onClick={() => setModalImagenAbierto(true)}
            />
          ) : (
            <div
              className="rounded-circle border d-flex justify-content-center align-items-center bg-light text-muted"
              style={{ height: "75px", width: "75px", cursor: "default", fontSize: "24px" }}
              onClick={() => setModalImagenAbierto(true)}
            >
              <i className="fas fa-user-slash"></i>
            </div>
          )}
<form onSubmit={handleSubmit(onSubmit)}>
  <div>
    <label>DNI:</label>
    <input {...register('dni')} disabled />
  </div>

  <div>
    <label>Apellido:</label>
    <input {...register('apellido')} />
  </div>

  <div>
    <label>Nombres:</label>
    <input {...register('nombres')} />
  </div>

  <div>
    <label>Email:</label>
    <input type="email" {...register('email')} />
  </div>

  <div>
    <label>Teléfono:</label>
    <input {...register('telefono')} />
  </div>

  <div>
    <label>Estado:</label>
    <input {...register('estado')} />
  </div>

  {/* 👇 campo oculto */}
  <input type="hidden" {...register('blanqueoContrasena')} />

  <button type="submit">Guardar</button>

  {/* 👇 botón de blanqueo */}
  <button
    type="button"
    onClick={() => {
      setValue('blanqueoContrasena', 0);
      handleSubmit(onSubmit)();
    }}
    style={{ marginLeft: '10px', background: '#d9534f', color: 'white' }}
  >
    Blanquear contraseña
  </button>
{estadoVirtual === "activo" ? (
  <>
    <div style={{ marginTop: '10px', fontWeight: 'bold', color: 'green' }}>
      ✅ Virtualizado
    </div>

    <button
      type="button"
      onClick={desvirtualizarUsuario}
      style={{ marginLeft: '10px', background: '#5bc0de', color: 'white' }}
    >
      Desvirtualizar Usuario
    </button>
  </>
) : (
  <button
    type="button"
    onClick={virtualizarUsuario}
    style={{ marginLeft: '10px', background: '#28a745', color: 'white' }}
  >
    Virtualizar Usuario
  </button>
)}
</form>

        </div>
        <ModalImagenUsuario
          isOpen={modalImagenAbierto}
          onRequestClose={() => setModalImagenAbierto(false)}
          ariaHideApp={false}
          style={customStyles}
        >

          {selectedUser ? <><SubirImagenPerfil dni={selectedUser.dni} imagenPasada={selectedUser.imagen }done={() =>{ setModalImagenAbierto(false);closeModalInformeDocentes()}}></SubirImagenPerfil></> : ""}


        </ModalImagenUsuario>
      </Modal>

      <div>
        <h1>Gestión de Usuarios del Sistema de Calificaciones ISeP</h1>
        <UsuarioBuscador devuelvo={(x) => handleEditClick(x)} />
      </div>  <button className='btn btn-success' onClick={() => setVeoCreoUsuarios(!veoCreaUsuarios)}>Crear Usuarios</button>
      {veoCreaUsuarios ? <>  <div>
        <button
          className='btn btn-primary'
          onClick={descargarEjemploCSV}
          style={{ margin: '10px 0' }}
        >
          Descargar archivo de ejemplo CSV
        </button>
        <CsvDropzone datos={(x) => enviarUsuariosMasivamente(x)} />

      </div></> : ""}

    </>
  );
};

export default GestorUsuariosCalificaciones;
